import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import React from "react";
import { css } from "styled-components";


interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    pageType: "PLP" | "PDP" | "Cart";
    isAuthenticated: boolean;
}

type Props = OwnProps;

export interface MultipleSaleQtyStyles {
  qtyWrapper?: InjectableCss;
  cartQtyWrapper?: InjectableCss;
  saleQtyMessage?: InjectableCss;
  cartSaleQtyMessage?: InjectableCss;
  plpSaleQtyMessage?: InjectableCss;
}

export const multipleSaleQtyStyles: MultipleSaleQtyStyles = {
   qtyWrapper:{
    css: css`
        text-align: left !important;
        padding: 4px 10px !important;
        margin: 5px 0px !important;
        border-left: 5px solid ${WhitecapColors.badgeBorderColor};
        background-color: ${getColor("primary.contrast")};
    `
   },
   cartQtyWrapper:{
    css: css`
        padding: 0;
        margin: 0;
        border-left: 0;
    `
   },
   cartSaleQtyMessage:{
    css: css`
        font-weight: 600;
        color: ${getColor("text.main")};
    `
   },
   saleQtyMessage:{
    css: css`
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: ${WhitecapColors.createAccountHeaderBtnColor}
    `
   },
   plpSaleQtyMessage:{
    css: css`
        font-size: 15px;
        font-weight: 500;
        line-height: 21px;
        color: ${WhitecapColors.createAccountHeaderBtnColor}
    `
   }
};

const styles = multipleSaleQtyStyles;

const MultipleSaleQtyMessage = ({ product, pageType, isAuthenticated }: Props) => {
    const multipleSaleQty =
       (product as any).product?.detail?.multipleSaleQty ??
       (product as any).properties?.multipleSaleQty ??
       0;
    
    if (multipleSaleQty <= 1) return null;

    
    let messageKey = "";

    //EC-1623 cart page message for logged in user and skip guest user
    if (pageType === "Cart") {
        if (!isAuthenticated) return null; 
        messageKey = "multiple_sale_qty_msg_cart"; 
    } else {
        // PLP & PDP for guest and logged-in user
        messageKey = isAuthenticated
            ? "multiple_sale_qty_msg" 
            : "multiple_sale_qty_msg_guest";
    }


    const multipleSaleQtyMsg = siteMessage(
        messageKey,
        `(${multipleSaleQty.toLocaleString()})`
    );

    return (
       <> 
            <StyledWrapper  {...(pageType === "Cart" ? styles.cartQtyWrapper : styles.qtyWrapper)} className="multiple_sale_qty_wrapper">
                <Typography as="span"   {...(
                        pageType === "Cart"
                            ? styles.cartSaleQtyMessage
                            : pageType === "PLP"
                            ? styles.plpSaleQtyMessage
                            : styles.saleQtyMessage
                    )} >
                   {multipleSaleQtyMsg}
                </Typography>
            </StyledWrapper>
        </>
    );
};


export default MultipleSaleQtyMessage;
